import React from 'react'
import PropTypes from 'prop-types'
import { Circle } from 'better-react-spinkit'
import { useStyles } from './loadingIndicator.css'

const LoadingIndicator = (props) => {
  const classes = useStyles()
  const { outerStyle, center, ...otherProps } = props
  return (<div className={`${classes.root} ${center ? classes.center : ''}`} style={outerStyle}>
    <Circle {...otherProps} />
  </div>)
}

LoadingIndicator.propTypes = {
  outerStyle: PropTypes.object, // style applied on wrapping DIV
  center: PropTypes.bool, // if true additional CSS is applied to center the spinner
  color: PropTypes.string, // The color of the spinner.
  scaleEnd: PropTypes.number, // End the animation with dots at x times the size value.
  scaleStart: PropTypes.number, // Start the animation with dots at x times the size value.
  size: PropTypes.number // The size of the spinner.
}

export default LoadingIndicator
